import { updateOnboardingChannelsApi as generatedUpdateOnboardingChannelsApi } from '../generated/onboarding/updateOnboardingChannels';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const updateOnboardingChannelsApi = generatedUpdateOnboardingChannelsApi.enhanceEndpoints({
  endpoints: {
    updateOnboardingChannels: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async ({ body }, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
            draft.channels = {
              ...draft.channels,
              ...body,
            };

            if (draft.progress != null) {
              draft.progress.channels = true;
            } else {
              draft.progress = { channels: true };
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useUpdateOnboardingChannelsMutation } = updateOnboardingChannelsApi;
